import { Alert } from "@mui/material";

import { RobotoDomainException } from "@/shared/http";

interface CommentsLoadErrorProps {
  error: unknown;
}

export function CommentsLoadError({ error }: CommentsLoadErrorProps) {
  if (error instanceof RobotoDomainException && error.isClientError()) {
    return <Alert severity="error">{error.message}</Alert>;
  }

  return (
    <Alert severity="error">
      Failed to load comments. Refresh the page to try again. Please contact{" "}
      <a href="mailto:support@roboto.ai">support@roboto.ai</a> if this problem
      persists.
    </Alert>
  );
}
